module.exports = __webpack_public_path__ + "static/media/1007153.5eeb3084.jpg";